export default __webpack_public_path__ + "static/media/ic-48-close-black2@3x.78afeb71.png";